import { Link } from "react-router-dom";

/**
 * Participant-facing chrome. Centered Leaply lockup (icon + wordmark) —
 * the same brand asset used for the favicon, NOT the prototype's
 * hand-kerned Rubik text wordmark. Rendered on every participant page
 * via App.tsx so the brand is present from welcome through /complete.
 */
export function Header() {
  return (
    <header className="px-5 py-4 sm:px-7 sm:py-5 lg:px-8 lg:py-6 flex items-center justify-center">
      <Link
        to="/"
        aria-label="Leaply — go to start"
        className="inline-flex items-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-muted hover:opacity-80 active:opacity-70 transition-opacity"
      >
        <img
          src="/leaply-lockup.png"
          alt="Leaply"
          className="h-7 sm:h-8 w-auto block"
          draggable={false}
        />
      </Link>
    </header>
  );
}
